<template>
  <v-container>
    <template>
      <v-btn color="lime darken-2" dark class="mb-3" @click="volver()">
        <v-icon right dark>arrow_back_ios</v-icon>Volver
      </v-btn>
    </template>
    <v-card>
      <v-container>
        <v-layout>
          <v-flex>
            <v-toolbar color="white" dark flat dense cad>
              <v-toolbar-title class="indigo--text"
                >Recepción de Cuadraturas Serie</v-toolbar-title
              >
            </v-toolbar>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex xs12 md12>
            <v-card max-width="100%" height="115">
              <v-card-text>Nivel: {{ this.idNivel }}</v-card-text>
              <v-card-text>Tipo De Prueba: {{ this.tipoPrueba }}</v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
        <br />
        <v-layout justify-center>
          <v-flex xs12 md4>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Código curso"
              single-line
              hide-details
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md1></v-flex>

          <v-flex xs12 md4>
            <v-select
              v-model="regionValue"
              @change="comunaFiltro()"
              item-text="nombre"
              item-value="code"
              :items="regionesSelect"
              label="Región"
            ></v-select>
          </v-flex>

          <v-flex xs12 md1></v-flex>
          <v-flex xs12 md4>
            <v-select
              v-model="comunaValue"
              item-text="nombre"
              item-value="code"
              :items="comunasSelect"
              label="Comuna"
            ></v-select>
          </v-flex>

          <v-btn
            fab
            dark
            color="teal"
            title="Filtrar detalle"
            @click="loadData(true)"
          >
            <v-icon dark>filter_list</v-icon>
          </v-btn>
          <v-btn
            fab
            dark
            color="red darken-4"
            title="Limpiar filtros"
            @click="clear()"
          >
            <v-icon dark>clear_all</v-icon>
          </v-btn>
        </v-layout>

        <div id="grid-cuadratura">
          <v-layout justify-center>
            <v-flex lg12>
              <div v-if="loading">
                <loading></loading>
              </div>
              <v-spacer></v-spacer>
              <v-data-table
                :headers="headers"
                :items="itemsCuadraturas"
                :search="search"
                :rows-per-page-items="rowsPerPageItems"
                class="elevation-1"
                hide-actions
              >
                <template v-slot:items="props">
                  <td class="text-xs-left">{{ props.item.idNivel }}</td>
                  <td class="text-xs-left">{{ props.item.tipoPrueba }}</td>
                  <td class="text-xs-left">{{ props.item.codigoCurso }}</td>
                  <td class="text-xs-left">{{ props.item.serie }}</td>
                  <!-- <td class="text-xs-left">{{ props.item.region}}</td> -->
                  <!-- <td v-if="props.item.cantPAMat == props.item.cantPAMat_REC" class="text-xs-center"
                    >{{ props.item.cantPAMat}}/{{ props.item.cantPAMat_REC}}</td>
                  <td v-if="props.item.cantPAMat != props.item.cantPAMat_REC" class="text-xs-center font-weight-bold red"
                    >{{ props.item.cantPAMat}}/{{ props.item.cantPAMat_REC}}</td>
                  <td v-if="props.item.cantPALen == props.item.cantPALen_REC" class="text-xs-center"
                    >{{ props.item.cantPALen}}/{{ props.item.cantPALen_REC}}</td>
                  <td v-if="props.item.cantPALen != props.item.cantPALen_REC" class="text-xs-center font-weight-bold red"
                    >{{ props.item.cantPALen}}/{{ props.item.cantPALen_REC}}</td> -->
                  <td class="text-xs-left">{{ props.item.cantPCMat_REC }}</td>
                  <td class="text-xs-left">{{ props.item.cantPAMat_REC }}</td>
                  <td class="text-xs-left">{{ props.item.cantPCLen_REC }}</td>
                  <td class="text-xs-left">{{ props.item.cantPALen_REC }}</td>
                  <td class="text-xs-left">{{ props.item.cantCe_REC }}</td>
                  <td class="text-xs-left">{{ props.item.cantCp_REC }}</td>
                  <td class="text-xs-left">{{ props.item.fechaReporte }}</td>
                </template>
              </v-data-table>
            </v-flex>
          </v-layout>
        </div>
        <br />

        <!-- dsoto -->
        <div class="text-center pt-2">
          <v-pagination
            @input="changePage(page)"
            v-model="page"
            :length="totalPages"
            :total-visible="9"
            circle
          >
          </v-pagination>
        </div>

        <v-card-actions class="pb-3">
          <v-spacer></v-spacer>
          <v-btn
            :loading="loading"
            color="primary"
            @click="descarga()"
            :disabled="botonDescarga"
            >Descarga Cuadraturas</v-btn
          >
          <v-spacer></v-spacer>
        </v-card-actions>

        <v-dialog v-model="dialogLoading" persistent max-width="390">
          <loading-descarga></loading-descarga>
        </v-dialog>
      </v-container>
    </v-card>
    <!-- nuevo modal proceso en curso (otro proceso se esta ejecutando, controlado por semaforo en controller!) -->
    <v-dialog v-model="procesoEnCurso" persistent max-width="600">
      <v-card>
        <v-card-title class="headline">Carga datos en proceso</v-card-title>
        <v-card-text>
          <v-flex lg12>
            <v-card-actions class="pb-3">
              <v-spacer></v-spacer>
            </v-card-actions>
            <div class="text-resp text-xs-center">
              <i
                class="fa fa-pause-circle text-danger fa-5x pb-3"
                aria-hidden="true"
                style="color: #f9a825"
              ></i
              ><br />
              <p>
                <b>Otro proceso se está ejecutando en estos momentos.</b>
              </p>
              <p>Por favor espere unos minutos y vuelva a intentarlo.</p>
              <v-btn color="primary" flat @click="cerrarModal()">Cerrar</v-btn>
            </div>
          </v-flex>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import axios from "axios";
import Loading from "@/views/ui/Loading.vue";
import AlertEmpty from "@/views/ui/AlertEmpty.vue";
import { misMixins } from "@/mixins/myMixing.js";
import LoadingDescarga from "@/views/ui/LoadingDescarga.vue";
import CargaMasiva from "@/components/CargaMasiva.vue";

export default {
  name: "grid-cuadratura",

  components: {
    Loading,
    AlertEmpty,
    LoadingDescarga,
    CargaMasiva,
  },
  mixins: [misMixins],
  props: {},

  data() {
    return {
      botonDescarga: true,
      procesoEnCurso: false,
      ocupado: true,
      search: "",
      page: 1,
      pages: 1,
      rowsPerPageItems: [20],
      totalPages: 0,
      total: "",
      dialogLoading: false,
      loading: false,
      usuarioLoggedTipe: "",
      idContrato: "",
      headers: [
        { text: "ID Nivel", align: "left", sortable: false, value: "nivel" },
        { text: "Tipo Prueba", sortable: false, value: "tipoPrueba" },
        { text: "Curso", align: "left", sortable: false, value: "codigoCurso" },
        { text: "Serie", sortable: false, value: "Serie" },
        { text: "PC Mat", sortable: false, value: "PC Mat" },
        { text: "PA Mat", sortable: false, value: "PA Mat" },
        { text: "PC Len", sortable: false, value: "PC Len" },
        { text: "PA Len", sortable: false, value: "PA Len" },
        { text: "CE", sortable: false, value: "CE" },
        { text: "CP", sortable: false, value: "CP" },
        { text: "Fecha Consolidacion", sortable: false, value: "fecha" },
      ],
      itemsCuadraturas: [],
      nivelSelect: [],
      nivelValue: null,
      tipoPruebaSelect: [],
      tipoPruebaValue: null,
      regionesSelect: [],
      regionValue: null,
      comunasSelect: [],
      comunaValue: null,
      codCursoValue: null,
      codCursoSelect: [],
      proceso: "",
      idNivel: "",
      tipoPrueba: "",
    };
  },
  watch: {
    dialogLoading(val) {
      if (!val) return;
      setTimeout(() => (this.dialogLoading = false), 5000);
    },
  },
  created() {
    this.idContrato = this.$store.getters.contratoStored;
    this.proceso = this.$store.getters.proSelectedStored;
    this.usuarioLoggedTipe = this.$store.getters.userLogged.tipo;

    this.tipoPrueba = this.$route.params.tipoPrueba;
    this.idNivel = this.$route.params.idNivel;

    this.id = this.$route.params.id;
    this.tab = this.$store.getters.subTabSelectedStored;

    this.loadData(true);
    this.loadDataComuna();
    this.loadDataCodigo();
    //para no permitir operaciones de carga
    // this.loadDataOcupado();
  },

  mounted() {},
  methods: {
    async loadCuadraturas() {
      this.body = {
        region:
          this.regionValue && this.regionValue != null
            ? this.regionValue
            : null,
        comuna:
          this.comunaValue && this.comunaValue != null
            ? this.comunaValue
            : null,

        codCurso: this.search,
        idContrato: this.idContrato,
        proceso: this.proceso,
        pageSize: 20,
        pageNumber: this.page,
        idNivel: this.idNivel,
        tipoPrueba: this.tipoPrueba,
      };
      return await axios
        .post("/cuadraturas/getAllSeriesByFilter", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            window.getApp.$emit("ERROR_EXCEPTION", error.response.data.message);
            this.loading = false;
          }
          return [{ total: 0, cuadraturas: [] }];
        });
    },
    async loadData(limpiar) {
      if (limpiar) this.page = 1;

      this.loading = true;
      var response = await this.loadCuadraturas();
      this.itemsCuadra = response;
      this.itemsCuadraturas = response.cuadraturas;

      if (this.itemsCuadraturas && this.itemsCuadraturas.length > 0) {
        this.pages = response.total;
        this.totalPages = Math.ceil(this.pages / 20);
        this.alerta = false;
        //ococupado = true => no descargar =>
        this.botonDescarga = this.ocupado;
      } else {
        this.alerta = true;
        this.botonDescarga = true;
        this.page = 1;
        this.totalPages = 0;
        this.pages = 1;
      }
      this.loading = false;
    },
    changePage(page) {
      this.page = page <= 0 || page > this.pages ? this.page : page;
      this.loadData(false);
    },
    cerrarModal() {
      this.procesoEnCurso = false;
    },
    descarga() {
      this.dialogLoading = true;
      let fileName = "Descarga_Cuadraturas_Serie.xlsx";

      this.body = {
        idContrato: this.idContrato,
        proceso: this.proceso,
        idNivel: this.idNivel,
        tipoPrueba: this.tipoPrueba,
      };
      axios
        .post("/cuadraturas/writeObjectToSC", this.body, {
          responseType: "blob",
        })
        .then(function (response) {
          const urle = window.URL.createObjectURL(response.data);
          const link = document.createElement("a");
          link.href = urle;
          link.setAttribute("download", fileName);
          document.body.appendChild(link);
          link.click();
          return response.data;
        })
        .catch(function (error) {
          console.log("st::detalle:" + JSON.stringify(error, null, 2));
          if (error.response.status === 503) {
            this.procesoEnCurso = true;
            console.log("Otro proceso en ejecución");
          } else {
            // Otro tipo de error, manejar segun sea necesario
            console.error("Error:", error.message);
            window.getApp.$emit("APP_PROCESS_ERROR", error.message);
          }
          return [];
        });
    },
    async loadDataOcupado() {
      this.ocupado = await this.loadOcupado();
      // console.log("ocupado:" + this.ocupado);
    },
    async loadOcupado() {
      this.body = {
        idContrato: this.idContrato,
      };
      return await axios
        .post("/captura/jobEnEjecucion", this.body)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            window.getApp.$emit("ERROR_EXCEPTION", error.message);
          }
          return [];
        });
    },
    async loadDataCodigo() {
      this.itemsCodigoCurso = await this.loadCodigoCurso();
      if (this.itemsCodigoCurso.length > 0) {
        this.codCursoSelect = this.itemsCodigoCurso;
      }
    },
    async loadCodigoCurso() {
      return await axios
        .get("/cuadraturas/codigoCurso/" + this.idContrato)
        .then(function (response) {
          return response.data;
        })
        .catch((error) => {
          if (error) {
            window.getApp.$emit("ERROR_EXCEPTION", error.message);
          }
          return [];
        });
    },
    clear() {
      this.regionValue = "";
      this.comunaValue = "";
      this.search = "";
      this.loadData(true);
    },
    volver() {
      this.$router.back();
    },
  },
};
</script>
